module.exports = __webpack_public_path__ + "img/statistics-icon03.4f0b4b56.png";